import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from 'react/elements/TextInput';
import { setGroceryRow } from 'redux/actions/calendar';

// The widths of grocery_list_added_items' columns (Grocery_Row_Set_Op), so a long entry is cut short
// here rather than refused by the server.
const FIELDS = [
	{ name: 'quantity', label: 'Amount', placeholder: '2 gallons, 1 box, a dozen', maxLength: 60 },
	{ name: 'notes', label: 'Notes', placeholder: 'Organic, the big one, on sale', maxLength: 500 },
];

const fieldsOf = (row) => ({ quantity: (row && row.quantity) || '', notes: (row && row.notes) || '' });

/**
 * How much of an item to buy on this trip and a note on it, in the item editor opened from a list
 * row: the row's own amount and notes, shown on the list under its name. Each saves when it is left,
 * as a `grocery.row_set` op, so it works offline. Leaving one empty clears it.
 *
 * The fields follow the store's copy of the row, so a change from another device shows here, except
 * while one is being typed in.
 */
export default function RowOnList({ rowId, heading = 'On this list' }) {
	const dispatch = useDispatch();
	const row = useSelector((state) => (state.food ? state.food.entities.groceryRows[rowId] : null));
	const [fields, setFields] = useState(() => fieldsOf(row));
	const [editing, setEditing] = useState(null);

	const stored = fieldsOf(row);
	useEffect(() => {
		setFields((current) => ({
			quantity: editing === 'quantity' ? current.quantity : stored.quantity,
			notes: editing === 'notes' ? current.notes : stored.notes,
		}));
	}, [stored.quantity, stored.notes]);

	if(!row) {
		return null;
	}

	const save = (name) => {
		setEditing(null);
		dispatch(setGroceryRow(rowId, { [name]: fields[name] }));
	};

	return (
		<section className='meal_idea_panel__section grocery_item_details__fields row_on_list'>
			<h6>{heading}</h6>
			{FIELDS.map((field) =>
			<label key={field.name} className='grocery_item_details__field'>
				<span className='grocery_item_details__label'>{field.label}</span>
				<span className='input-field'>
					<TextInput
						aria-label={field.label}
						placeholder={field.placeholder}
						maxLength={field.maxLength}
						value={fields[field.name]}
						onFocus={() => setEditing(field.name)}
						onChange={(event) => {
							const value = event.target.value;
							setFields((current) => ({ ...current, [field.name]: value }));
						}}
						onBlur={() => save(field.name)}
						onKeyDown={(event) => {
							if(event.key === 'Enter') {
								event.preventDefault();
								event.target.blur();
							}
						}}
					/>
				</span>
			</label>
			)}
		</section>
	);
}
